var map = {
	"./2016.svg": "8030",
	"./2017.svg": "f37c",
	"./2018.svg": "01ed",
	"./2019.svg": "5060",
	"./2020.svg": "3b84",
	"./2021.svg": "b22e",
	"./2022.svg": "5c10",
	"./2023.svg": "c5ea",
	"./2024.svg": "3e0b",
	"./2025.svg": "aea9",
	"./2026.svg": "b52a",
	"./2027.svg": "845e",
	"./2028.svg": "0604"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d4c1";